/* eslint-disable react/no-unstable-nested-components */
import React, { } from "react";
import { Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";

import BuildTargets from "./BuildTargets";
import { setEditTarget } from "../../store/components/BuildTargets.slice";

const BuildTargetsDrawer = function () {
    const dispatch = useDispatch();
    const { editTarget } = useSelector((state) => state.buildTargets);

    return (
        <Drawer
            className="buildtargets-drawer"
            placement="bottom"
            maskClosable={false}
            closable={false}
            onClose={() => {
                dispatch(setEditTarget(false));
            }}
            open={editTarget}
            height="calc(100% - 16mm)"
        >
            <BuildTargets />
        </Drawer>
    );
};

export default BuildTargetsDrawer;
